export default __webpack_public_path__ + "static/media/STL_Financial_Standealone_March_2026.14a65a13.pdf";